export default __webpack_public_path__ + "static/media/vin.1d89a4a9.svg";